<form [formGroup]="quizForm">
  <div class="modal-overlay">
    <div class="quiz-modal">
      <div class="qm-header">
        <div>
          <div class="qm-title">
            <i class="bi bi-card-text me-1"></i>Add Assessment
          </div>
          <div class="qm-sub">
            Configure assessment details, audience and proctoring before adding
            questions
          </div>
        </div>
        <span class="close" (click)="closeDialog()">
          <i class="bi bi-x-lg"></i>
        </span>
      </div>

      <div class="qm-body">
        <div class="qm-section">
          <div class="qm-sec-head">
            <div class="step">1</div>
            <div>
              <div class="sec-title">
                <i class="bi bi-card-text me-2"></i>
                Assessment details
              </div>
              <div class="sec-sub">
                Give your assessment a clear name and description
              </div>
            </div>
          </div>

          <div class="qm-content">
            <div class="field-group">
              <label class="field-label"
                >Assessment Title
                <span class="req">*</span>
              </label>
              <input
                placeholder="e.g Placement KickStart Assessment"
                formControlName="quiz_name" maxlength="100"
              />
              <small *ngIf="
                quizForm.get('quiz_name')?.dirty &&
                quizForm.get('quiz_name')?.hasError('maxLength')"
              class="text-danger smaller-text"            >
              Assessment title must not exceed 100 characters.
            </small>

            <small class="text-danger smaller-text"
              *ngIf="
                quizForm.get('quiz_name')?.dirty &&
                quizForm.get('quiz_name')?.hasError('invalidQuizName')
              ">            >
              Only letters, numbers, spaces, parentheses and hyphens are allowed.
          </small>
            </div>
            <div class="field-group">
              <div class="label-row" style="display: flex; align-items: center">
                <label
                  class="field-label"
                  style="display: flex; align-items: center; margin: 0"
                  >Map to Company
                  <mat-spinner
                    *ngIf="isLoadingCompanies"
                    diameter="14"
                    class="ms-2"
                  ></mat-spinner>
                </label>
                <span class="optional">Optional</span>
              </div>
              <select
                formControlName="map_to_company"
                style="width: 100%; margin-top: 6px"
                [attr.disabled]="isLoadingCompanies ? true : null"
              >
                <option value="" disabled selected>
                  {{
                    isLoadingCompanies
                      ? "Loading companies..."
                      : companies.length === 0
                        ? "No approved companies available"
                        : "Select Company"
                  }}
                </option>
                <option *ngFor="let c of companies" [value]="c.company_id">
                  {{ c.company_name }}
                </option>
              </select>
            </div>

            <div class="field-group">
              <div class="label-row" style="display: flex; align-items: center">
                <label
                  class="field-label"
                  style="display: flex; align-items: center; margin: 0"
                  >Map to Job
                  <span
                    *ngIf="quizForm.get('map_to_company')?.value"
                    class="req ms-1"
                    >*</span
                  >
                  <mat-spinner
                    *ngIf="isLoadingJobs"
                    diameter="14"
                    class="ms-2"
                  ></mat-spinner>
                </label>
                <span
                  class="optional"
                  *ngIf="!quizForm.get('map_to_company')?.value"
                  >Optional</span
                >
              </div>
              <select
                formControlName="map_to_job"
                style="width: 100%; margin-top: 6px"
                [attr.disabled]="
                  !quizForm.get('map_to_company')?.value ||
                  isLoadingJobs ||
                  (quizForm.get('map_to_company')?.value && jobs.length === 0)
                    ? true
                    : null
                "
              >
                <option value="" disabled selected>
                  {{
                    isLoadingJobs
                      ? "Loading jobs..."
                      : !quizForm.get("map_to_company")?.value
                        ? "Select a Company first"
                        : jobs.length === 0
                          ? "No active jobs available"
                          : "Select Job"
                  }}
                </option>
                <option *ngFor="let j of jobs" [value]="j.job_id">
                  {{ j.job_title }} ({{ j.job_role_category }})
                </option>
              </select>
            </div>

            <div class="field-group">
              <div class="label-row">
                <label class="field-label">Assessment Description</label>
                <span class="optional">Optional</span>
              </div>
              <textarea
                placeholder="Briefly describe what this assessment covers..."
                formControlName="description"
                maxlength="500"
              ></textarea>
              <small class="text-danger smaller-text"
                *ngIf="
                  quizForm.get('description')?.dirty &&
                  quizForm.get('description')?.hasError('maxLength')
                ">
                Assessment description must not exceed 500 characters.
            </small>
            </div>
          </div>
        </div>
      
  
        <div class="qm-section">
          <div class="qm-sec-head">
            <div class="step">2</div>
            <div>
              <div class="sec-title">
                <i class="bi bi-sliders me-2"></i>
                Configuration
              </div>
              <div class="sec-sub">
                Control how students experience the assessment
              </div>
            </div>
          </div>

          <div class="qm-content grid-2">
            <div class="field-group">
              <label class="field-label"
                >Duration
                <span class="req">*</span>
              </label>

              <div class="time-input" formGroupName="time_limit">
                <input
                  type="text"
                  formControlName="hours"
                  placeholder="HH"
                  maxlength="2"
                  (input)="handleTimeInput($event, 23)"
                />
                <span>:</span>
                <input
                  type="text"
                  formControlName="minutes"
                  placeholder="MM"
                  maxLength="2"
                  (input)="handleTimeInput($event, 59)"
                />
                <span>:</span>
                <input
                  type="text"
                  formControlName="seconds"
                  placeholder="SS"
                  maxLength="2"
                  (input)="handleTimeInput($event, 59)"
                />
              </div>
            </div>

            <div class="field-group" *ngIf="!isPublishedAsMockTest">
              <label class="field-label"
                >Attempts Allowed
                <span class="req">*</span>
              </label>
              <input
                formControlName="attempts_allowed"
                placeholder="e.g. 3"
                type="text"
                min="1"
                maxlength="3"
                inputmode="numeric"
                (keydown)="preventNegative($event)"
              />
            </div>

            <div class="field-group">
              <label class="field-label">Passing Score (%)</label>
              <input
                formControlName="passing_score"
                placeholder="e.g. 60%"
                type="text"
                inputmode="numeric"
                min="1"
                maxlength="3"
                (keydown)="preventNegative($event)"
              />
            </div>

            <div class="field-group">
              <div class="label-row">
                <label class="field-label"
                  >No. of Questions per User<span class="req"> *</span></label
                >
                <span class="serve">Served per attempt</span>
              </div>
              <input
                formControlName="questions_per_quiz"
                placeholder="e.g. 10"
                type="text"
                inputmode="numeric"
                maxLength="3"
                (keydown)="preventNegative($event)"
              />
            <small class="text-danger smaller-text"
            *ngIf="
              quizForm.get('questions_per_quiz')?.dirty &&
              quizForm.get('questions_per_quiz')?.hasError('pattern')
            ">
            No. of questions must be between 1 and 3 digits.
            </small>
            </div>
          </div>

          <div class="divider"></div>

          <div class="toggle-row">
            <div class="toggle-text">
              <span class="title">Shuffle questions</span>
              <p class="desc">
                Randomize the order of questions for each attempt
              </p>
            </div>
            <label class="switch">
              <input type="checkbox" formControlName="shuffle_questions" />
              <span class="slider"></span>
            </label>
          </div>

          <div class="toggle-row">
            <div class="toggle-text">
              <span class="title">Shuffle options</span>
              <p class="desc">Randomize the order of answer now</p>
            </div>
            <label class="switch">
              <input type="checkbox" formControlName="shuffle_options" />
              <span class="slider"></span>
            </label>
          </div>
        </div>

        <!-- <div class="qm-section">
          <div class="qm-sec-head">
            <div class="step">3</div>
            <div>
              <div class="sec-title">
                <i class="bi bi-people me-2"></i>Quiz mode
              </div>
              <div class="sec-sub">Choose who will take this quiz</div>
            </div>
          </div>

          <label class="field-label">Select mode *</label>

          <div class="mode-row">
            <label class="mode-card" [class.active]="mode === 'course'">
              <input
                type="radio"
                name="mode"
                value="course"
                formControlName="mode"
              />

              <div class="mode-text">
                <div class="mode-title">Publish to Course</div>
                <div class="mode-desc">
                  Assign to everyone enrolled in a course
                </div>
              </div>
            </label>

            <label class="mode-card" [class.active]="mode === 'group'">
              <input
                type="radio"
                name="mode"
                value="group"
                formControlName="mode"
                (ngModelChange)="onModeChange($event)"
              />

              <div class="mode-text">
                <div class="mode-title">Independent Assessment</div>
                <div class="mode-desc">Assign to selected user groups</div>
              </div>
            </label>
          </div>

          <div *ngIf="mode === 'course'">
            <label class="field-label"
              >Select course <span class="req">*</span>
            </label>
            <select class="dropdown" formControlName="course">
              <option [ngValue]="null" disabled>Choose a course...</option>
              <option *ngFor="let course of courses" [value]="course.id">
                {{ course.name }}
              </option>
            </select>

            <div class="info-box">
              <i class="bi bi-info-circle me-2"></i>
              This assessment will be automatically assigned to all students enrolled
              in the selected course.
            </div>
          </div>

          <div *ngIf="mode === 'group'">
            <label class="field-label">Select user group *</label>

            <div class="custom-dropdown" (click)="toggleGroupDropdown()">
              <div class="dropdown-display">
                {{
                  quizForm.get("groups")?.value?.length
                    ? quizForm.get("groups")?.value.join(", ")
                    : "Choose a user group..."
                }}
              </div>

              <div class="arrow">&#9662;</div>
              <div
                class="dropdown-list"
                *ngIf="isGroupDropdownOpen"
                (click)="$event.stopPropagation()"
              >
                <label
                  class="dropdown-item"
                  *ngFor="let group of userGroups"
                  [class.selected]="selectedGroups.includes(group)"
                >
                  <input
                    type="checkbox"
                    [checked]="selectedGroups.includes(group)"
                    (change)="onSelectGroup(group)"
                  />
                  {{ group }}
                </label>
              </div>
            </div>
          </div>
        </div> -->

        <div class="qm-section">
          <div class="qm-sec-head">
            <div class="step">3</div>
            <div>
              <div class="sec-title">
                <i class="bi bi-shield-check me-2"></i>
                Proctoring
              </div>
              <div class="sec-sub">
                Enable monitoring to maintain assessment integrity
              </div>
            </div>
          </div>
          <div class="toggle-row">
            <div>
              <div class="field-title">Enable proctoring</div>
              <div class="sec-sub">
                {{
                  quizForm.get("isProctored")?.value
                    ? "Proctored — monitoring features are active"
                    : "Non-proctored - no monitoring applied"
                }}
              </div>
            </div>

            <label class="switch">
              <input type="checkbox" formControlName="isProctored" />
              <span class="slider"></span>
            </label>
          </div>

          <div class="proctor-options">
            <div
              *ngIf="quizForm.get('isProctored')?.value"
              formGroupName="proctoring_config"
            >
              <label class="proctor-item">
                <input type="checkbox" formControlName="detect_tab_switch" />
                <span>Detect Tab Switch</span>
              </label>

              <label class="proctor-item">
                <input type="checkbox" formControlName="restrict_new_tabs" />
                <span>Restrict New Tabs</span>
              </label>

              <label class="proctor-item">
                <input type="checkbox" formControlName="enable_camera" />
                <span>Enable Camera</span>
              </label>

              <label class="proctor-item">
                <input type="checkbox" formControlName="face_detection" />
                <span>Face Detection</span>
              </label>

              <label class="proctor-item">
                <input
                  type="checkbox"
                  formControlName="multiple_person_detection"
                />
                <span>Multiple Person Detection</span>
              </label>

              <label class="proctor-item">
                <input type="checkbox" formControlName="no_talking_detection" />
                <span>No Talking Detection</span>
              </label>

              <label class="proctor-item">
                <input
                  type="checkbox"
                  formControlName="eye_movement_tracking"
                />
                <span>Eye Movement Tracking</span>
              </label>
            </div>
          </div>
        </div>
        <ng-container *hasPermission="PermissionForStudents.MOCK_TEST">
       <div class="publish-mock-test-section">
            <div class="publish-mock-test-card">
              <div class="publish-card-top">
                <div class="publish-card-icon">
                  <span>4</span>
                </div>
                <div class="publish-card-info">
                  <h3>Publish as Mock Test</h3>
                  <p>
                    Make this assessment available as a public mock test on the
                    BeExpert platform.
                  </p>
                </div>
              </div>
              <div class="publish-card-bottom">
                <span class="publish-toggle-label" (click)="publishMockTestInput.click()">Publish as Mock Test</span>
                <label class="publish-toggle">
                  <input
                    #publishMockTestInput
                    id="publishMockTest"
                    type="checkbox"
                    [checked]="isPublishedAsMockTest"
                    (change)="onMockTestToggle($any($event.target).checked)"
                  />
                  <span class="publish-toggle-slider"></span>
                </label>
              </div>
            </div>
      </div>
    </ng-container>

        <!-- <div class="qm-section">
          <div class="qm-sec-head">
            <div class="step">4</div>
            <div>
              <div class="sec-title">
                <i class="bi bi-calendar me-2"></i>Schedule
              </div>
              <div class="sec-sub">
                Optionally limit when this assessment is available
              </div>
            </div>
          </div>

          <div class="grid-2">
            <div>
              <label class="field-label">
                Start date & time <span class="optional">Optional</span>
              </label>

              <div class="input-wrapper">
                <input
                  type="datetime-local"
                  formControlName="start_date_time"
                  class="input"
                />
              </div>
            </div>

            <div>
              <label class="field-label">
                End date & time <span class="optional">Optional</span>
              </label>

              <div class="input-wrapper">
                <input
                  type="datetime-local"
                  formControlName="end_date_time"
                  class="input"
                />
              </div>
            </div>
          </div>

          <div class="mt-12">
            <label class="field-label">Time zone</label>
            <select class="dropdown" formControlName="timeZone">
              <option>IST (UTC+05:30)</option>
            </select>
          </div>  not using for now
        </div> -->
      </div>
      <div class="qm-footer">
        <button class="btn-cancel" type="button" (click)="closeDialog()">
          Cancel
        </button>
        <button
          class="btn-primary"
          type="button"
          (click)="createQuiz()"
          [disabled]="!isFormValid"
        >
          <ng-container *ngIf="isAdding; else noAdding">
            <span class="spinner-text">
              <mat-spinner [diameter]="20" class="spinner-white"></mat-spinner>
              Adding...
            </span>
          </ng-container>
          <ng-template #noAdding>
            <i class="bi bi-plus"></i>
            Continue to Questions
          </ng-template>
        </button>
      </div>
    </div>
  </div>
</form>
